const analyticsEvent = require('../analytics/analyticsEvent');
import * as VanillaSharing from 'vanilla-sharing';

module.exports = (meta, buttonSelector) => {
    const shareButtons = [...document.querySelectorAll(buttonSelector)];

    if (shareButtons.length > 0) {

        const shareOptions = {
            url: meta.url,
            title: meta.title,
            description: meta.description,
            image: meta.image,
            isVkParse: false,
            fbAppId: meta.fbappid
        };

        shareButtons.forEach(button => {
            button.addEventListener('click', () => {
                VanillaSharing[button.dataset.social](shareOptions);
                analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
            });
        });

    }
};



// WEBPACK FOOTER //
// ./js/viscom/viscomjs/ui/ShareButtons.js